import { selectPlaygroundWarehouses } from 'containers/Playground/playgroundSlice'
import usePlaceMapParams from './usePlaceMapParams'
import { useEffect, useState } from 'react'
import { useReduxSelector } from 'store'

const useSelectedWarehouse = () => {
  const { id } = usePlaceMapParams()
  const [warehouseId, setWarehouseId] = useState(id)
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)

  useEffect(() => {
    if (id) {
      setWarehouseId(id)
    } else {
      const timeout = setTimeout(() => {
        setWarehouseId(undefined)
      }, 300)
      return () => {
        clearTimeout(timeout)
      }
    }

  }, [id])

  const findWarehouse = (list?: playground.Warehouse[]): playground.Warehouse | undefined => {
    if (!warehouseId || !list) return undefined
    for (const warehouse of list) {
      if (warehouse.typeId === warehouseId) {
        return warehouse
      } else if (warehouse.children) {
        const foundWarehouse = findWarehouse(warehouse.children)
        if (foundWarehouse) {
          return foundWarehouse
        }
      }
    }
  }
  return findWarehouse(warehouses)
}

export default useSelectedWarehouse